import React, { useState } from 'react';

import { useTranslation } from 'react-i18next';
// import { DndContext, closestCorners } from '@dnd-kit/core';
// import { SortableContext, arrayMove, rectSwappingStrategy } from '@dnd-kit/sortable';
import { Container } from 'src/components/layouts/Container/Container';
// import PopularProductsCard from 'src/components/cardLayouts/PopularProductsCard/PopularProductsCard';
// import NotificationCard from 'src/components/cardLayouts/NotificationCard/NotificationCard';
// import ParcelStatusCard from 'src/components/cardLayouts/ParcelStatusCard/ParcelStatusCard';
import StatisticRow from 'src/components/cardLayouts/StatisticRow/StatisticRow';
// import ScoreCard from 'src/components/cardLayouts/ScoreCard/ScoreCard';
// import DestinationsCard from 'src/components/cardLayouts/DestinationsCard/DestinationsCard';
// import ReturnsAndReasonsCard from 'src/components/cardLayouts/ReturnsAndReasonsCard/ReturnsAndReasonsCard';
// import Draggable from 'src/components/layouts/Draggable/Draggable';
import AddWidgetModal from 'src/components/modals/AddWidgetModal/AddWidgetModal';
// import { HeaderItemProps } from 'src/components/ui/HeaderItem/HeaderItem';
// import LineChartCard from 'src/components/cardLayouts/LineChartCard/LineChartCard';
import HeadlineWithButtons from 'src/components/ui/HeadlineWithButtons/HeadlineWithButtons';
import useUserProfile from 'src/services/profile';
import { DashboardKpi, useDashboardKpiQuery } from 'src/services/kpi';
import KeyValueListWithDiagramKpiCard from 'src/components/cardLayouts/KeyValueListWithDiagramKpiCard/KeyValueListWithDiagramKpiCard';
import DashboardKeyValueListKpiCard from 'src/components/cardLayouts/DashboardKeyValueListKpiCard/DashboardKeyValueListKpiCard';
import DashboardCircleProgressDiagramKpiCard from 'src/components/cardLayouts/DashboardCircleProgressDiagramKpiCard/DashboardCircleProgressDiagramKpiCard';
import DashboardAvgCalcWithProgressKpiCard from 'src/components/cardLayouts/DashboardAvgCalcWithProgressKpiCard/DashboardAvgCalcWithProgressKpiCard';
import DashboardTimeSeriesDiagramKpiCard from 'src/components/cardLayouts/DashboardTimeSeriesDiagramKpiCard/DashboardTimeSeriesDiagramKpiCard';
import DashboardKeyValueRankingKpiCard from 'src/components/cardLayouts/DashboardKeyValueRankingKpiCard/DashboardKeyValueRankingKpiCard';
import { convertKpiToHeaderItemProps } from 'src/components/layouts/KpiRow.tsx/KpiRow';
import DashboardBarChartDiagramKpiCard from 'src/components/cardLayouts/DashboardBarChartDiagramKpiCard/DashboardBarChartDiagramKpiCard';
import PeriodBar, { PeriodRange, resolvePreset } from 'src/components/ui/PeriodBar/PeriodBar';

function Dashboard() {
  const { t } = useTranslation();
  const { profile } = useUserProfile();
  const baseUrl = window.location.origin;
  const [isAddWidgetModalOpen, setIsAddWidgetModalOpen] = useState(false);
  const [range, setRange] = useState<PeriodRange>(() => resolvePreset('last_30_days'));
  const { data } = useDashboardKpiQuery('main.dashboard', range.from, range.to);
  const kpis = data as DashboardKpi[] | undefined;
  const periodLabel = t(`period.labels.${range.key}`, { defaultValue: range.label });

  // Define the type explicitly for the array
  // const buttons = [
  //   dashboardState.isAdjusting
  //     ? {
  //         title: 'abbrechen',
  //         tone: ButtonToneProps.SECONDARY,
  //         onClick: () => {
  //           store.dispatch(setIsAdjusting());
  //         },
  //       }
  //     : undefined,
  //   dashboardState.isAdjusting
  //     ? {
  //         title: 'Widget hinzufügen',
  //         tone: ButtonToneProps.SECONDARY,
  //         icon: 'plus' as IconName,
  //         onClick: () => {
  //           setIsAddWidgetModalOpen(true);
  //         },
  //       }
  //     : undefined,
  //   !dashboardState.isAdjusting
  //     ? {
  //         title: t('dashboard.time_period', { period: 30 }),
  //         tone: ButtonToneProps.SECONDARY,
  //         icon: 'calendar-today' as IconName,
  //         onClick: () => {},
  //       }
  //     : undefined,
  //   {
  //     title: dashboardState.isAdjusting ? t('dashboard.save') : t('dashboard.adjust'),
  //     tone: ButtonToneProps.PRIMARY_BLUE,
  //     onClick: () => {
  //       store.dispatch(setIsAdjusting());
  //     },
  //   },
  // ].filter(e => e?.title) as ButtonProps[];

  // const [widgets, setWidgets] = useState([
  //   { id: 'header', component: <StatisticRow items={kpiData} /> },
  //   {
  //     id: 'deliveriesCard',
  //     component: (
  //       <LineChartCard
  //         title="Auslieferungen"
  //         kpi={{ percentage: -0.2, value: '1.234', label: 'Ø Versandrate: 64/Tag' }}
  //       />
  //     ),
  //   },
  //   { id: 'score', component: <ScoreCard score={80} label="label" /> },
  //   { id: 'notifications', component: <NotificationCard items={notificationCardItems} /> },
  //   {
  //     id: 'destinationCard',
  //     component: (
  //       <DestinationsCard totalDestinationPackages="100" packagesPercentageByDestination={['67%', '20%', '8%', '5%']} />
  //     ),
  //   },
  //   {
  //     id: 'returnsAndReasonsCard',
  //     component: (
  //       <ReturnsAndReasonsCard
  //         totalReturnsPercentage="4.6%"
  //         returnsChangePercentage={0.2}
  //         reasonsPercentage={['67%', '20%', '8%', '5%']}
  //       />
  //     ),
  //   },
  //   { id: 'parcelStatus', component: <ParcelStatusCard /> },
  //   {
  //     id: 'deliveriesCard-expanded',
  //     component: (
  //       <LineChartCard title="Retouren" kpi={{ percentage: 0.2, value: '1.234', label: 'Ø Retourenrate: 2/Tag' }} />
  //     ),
  //   },
  //   { id: 'popularProducts', component: <PopularProductsCard items={productListItems} /> },
  // ]);

  // const handleDragEnd = (event: any) => {
  //   const { active, over } = event;
  //   if (over && active.id !== over.id) {
  //     setWidgets(widgets => {
  //       const oldIndex = widgets.findIndex(widget => widget.id === active.id);
  //       const newIndex = widgets.findIndex(widget => widget.id === over.id);
  //       return arrayMove(widgets, oldIndex, newIndex);
  //     });
  //   }
  // };

  const listItems = [
    { cardType: 'Übersicht', cardImage: `${baseUrl}/widget.jpg` },
    { cardType: 'Auslieferungen', cardImage: `${baseUrl}/widget.jpg` },
    { cardType: 'Benachrichtigungen', cardImage: `${baseUrl}/widget.jpg` },
    { cardType: 'Destinationen', cardImage: `${baseUrl}/widget.jpg` },
    { cardType: 'Retourenquote & Gründe', cardImage: `${baseUrl}/widget.jpg` },
    { cardType: 'Retouren', cardImage: `${baseUrl}/widget.jpg` },
    { cardType: 'Sendungen nach Status', cardImage: `${baseUrl}/widget.jpg` },
    { cardType: 'Am meisten versandte Produkte', cardImage: `${baseUrl}/widget.jpg` },
    { cardType: 'Pakete', cardImage: `${baseUrl}/widget.jpg` },
  ];

  return (
    <Container buttons={[]}>
      <div className="dashboard">
        <HeadlineWithButtons headline={profile.name ? `${t('general.hello')}, ${profile.name}` : t('general.hello')} />
        <div className="mb-20">
          <PeriodBar value={range} onChange={setRange} />
        </div>
        <AddWidgetModal
          isOpen={isAddWidgetModalOpen}
          onClose={() => setIsAddWidgetModalOpen(false)}
          listItems={listItems}
        />
        <div className="grid grid-cols-1 md:grid-cols-2 gap-20 mb-20">
          {kpis?.map((kpi, idx) => {
            if (kpi.kpi_type === 'key_value_list_with_diagram') {
              return (
                // eslint-disable-next-line react/no-array-index-key
                <div key={idx}>
                  <div className="h-full">
                    <KeyValueListWithDiagramKpiCard data={kpi} />
                  </div>
                </div>
              );
            }
            if (kpi.kpi_type === 'dashboard_key_value_list') {
              return (
                // eslint-disable-next-line react/no-array-index-key
                <div key={idx}>
                  <div className="h-full">
                    <DashboardKeyValueListKpiCard data={kpi} />
                  </div>
                </div>
              );
            }
            if (kpi.kpi_type === 'dashboard_circle_progress_diagram') {
              return (
                // eslint-disable-next-line react/no-array-index-key
                <div key={idx}>
                  <div>
                    <DashboardCircleProgressDiagramKpiCard data={kpi} />
                  </div>
                </div>
              );
            }
            if (kpi.kpi_type === 'dashboard_avg_calc_with_progress') {
              return (
                // eslint-disable-next-line react/no-array-index-key
                <div key={idx}>
                  <div>
                    <DashboardAvgCalcWithProgressKpiCard data={kpi} />
                  </div>
                </div>
              );
            }
            if (kpi.kpi_type === 'dashboard_time_series_diagram') {
              return (
                // eslint-disable-next-line react/no-array-index-key
                <div key={idx}>
                  <div>
                    <DashboardTimeSeriesDiagramKpiCard
                      data={kpi}
                      title={`${t('dashboard.charts.imported_orders')} · ${periodLabel}`}
                    />
                  </div>
                </div>
              );
            }
            if (kpi.kpi_type === 'dashboard_key_value_ranking') {
              return (
                // eslint-disable-next-line react/no-array-index-key
                <div key={idx}>
                  <div className="h-full">
                    <DashboardKeyValueRankingKpiCard data={kpi} />
                  </div>
                </div>
              );
            }
            if (kpi.kpi_type === 'top_kpis') {
              const resolved = convertKpiToHeaderItemProps(kpi.data, t).map((item, i) => ({
                ...item,
                description:
                  kpi.data[i]?.key === 'open_cases'
                    ? t('dashboard.total_independent')
                    : kpi.data[i]?.time_span
                      ? periodLabel
                      : item.description,
              }));
              return (
                // eslint-disable-next-line react/no-array-index-key
                <div key={idx} className="col-span-full">
                  <div>
                    <StatisticRow items={resolved} />
                  </div>
                </div>
              );
            }
            if (kpi.kpi_type === 'dashboard_bar_chart_diagram') {
              return (
                // eslint-disable-next-line react/no-array-index-key
                <div key={idx} className="col-span-full">
                  <div>
                    <DashboardBarChartDiagramKpiCard
                      title={`${t('dashboard.charts.order_status')} · ${periodLabel}`}
                      data={kpi}
                    />
                  </div>
                </div>
              );
            }
            return null;
          })}

          {/* hardcoded for now */}
          {/* <div className="col-span-full"> */}
          {/*  <div> */}
          {/*    <DashboardBarChartDiagramKpiCard title="Auslieferungen" /> */}
          {/*  </div> */}
          {/* </div> */}
        </div>
        {/* <DndContext collisionDetection={closestCorners} onDragEnd={handleDragEnd}>
          <SortableContext items={widgets.map(widget => widget.id)} strategy={rectSwappingStrategy}>
            <div>
              <div>
                <Draggable key={widgets[0].id} id={widgets[0].id}>
                  {widgets[0].component}
                </Draggable>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-20 py-20">
              <Draggable key={widgets[1].id} id={widgets[1].id}>
                {widgets[1].component}
              </Draggable>
              <Draggable key={widgets[2].id} id={widgets[2].id}>
                {widgets[2].component}
              </Draggable>
            </div>
            <div className="grid grid-cols-2 gap-20">
              <Draggable key={widgets[3].id} id={widgets[3].id}>
                {widgets[3].component}
              </Draggable>
              <Draggable key={widgets[4].id} id={widgets[4].id}>
                {widgets[4].component}
              </Draggable>
            </div>
            <div className="grid grid-cols-2 gap-20">
              <Draggable key={widgets[5].id} id={widgets[5].id}>
                {widgets[5].component}
              </Draggable>
              <Draggable key={widgets[6].id} id={widgets[6].id}>
                {widgets[6].component}
              </Draggable>
            </div>
            <div className="grid grid-cols-4 gap-20">
              <div className="col-span-2">
                <Draggable key={widgets[7].id} id={widgets[7].id}>
                  {widgets[7].component}
                </Draggable>
              </div>
              <div className="col-span-2">
                <Draggable key={widgets[8].id} id={widgets[8].id}>
                  {widgets[8].component}
                </Draggable>
              </div>
            </div>
          </SortableContext>
        </DndContext> */}
      </div>
    </Container>
  );
}

export default Dashboard;
